import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  GetCategories,
  CreateCategory,
  UpdateCategory,
  DeleteCategory,
} from "../Api";
import {
  LOOKUP_STALE_TIME,
  ServiceQueryOptions,
  unwrapApiResponse,
} from "./query_helpers";

export const categoryQueryKeys = {
  categories: () => ["categories"] as const,
};

export const invalidateCategoryQueries = (queryClient: any) => {
  queryClient.invalidateQueries({ queryKey: ["categories"] });
};

export const useCategoriesQuery = (options?: ServiceQueryOptions) => {
  return useQuery({
    staleTime: LOOKUP_STALE_TIME,
    ...options,
    queryKey: categoryQueryKeys.categories(),
    queryFn: async () => unwrapApiResponse(await GetCategories()),
  });
};

export const useCategoriesRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      queryClient.fetchQuery({
        staleTime: LOOKUP_STALE_TIME,
        queryKey: categoryQueryKeys.categories(),
        queryFn: async () => unwrapApiResponse(await GetCategories()),
      }),
  });
};

export const useCreateCategoryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof CreateCategory>[0]) =>
      CreateCategory(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateCategoryQueries(queryClient);
      }
    },
  });
};

export const useUpdateCategoryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof UpdateCategory>[0]) =>
      UpdateCategory(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateCategoryQueries(queryClient);
      }
    },
  });
};

export const useDeleteCategoryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof DeleteCategory>[0]) =>
      DeleteCategory(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateCategoryQueries(queryClient);
      }
    },
  });
};
